import { ActivityStore } from "../store/activity/ActivityStore";

export const useIsTradeHistoryReturned = () => {
  const { data } = ActivityStore.useState(s => s.history);
  return data !== undefined;
};
